import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { requests } from "../../../common/RestAPI";
import { base64Decoding, base64Encoding } from "../../../common/util";
import { SESSIONSTORAGE } from "../../../value/staticValues";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";
import { useTranslation } from "react-i18next";
import MyInfoDetail from "./MyInfoDetail";
import { MyInfoData, accountUpdateModalContent, initMyInfoData } from "./MyInfoData";
import { View } from "react-native";


export interface DetailProps {
    setLoading: Function;
    showSlideModalCb?: Function;
    showPopupModalCb: Function;
}

export default function MyInfoDetailContainter(props:DetailProps) {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);
    const [targetId, setTargetId] = useState("");
    const [refreshYn, setRefreshYn] = useState(false);
    const [myInfoData, setMyInfoData] = useState<MyInfoData>(initMyInfoData);


    useEffect(() => {
        props.setLoading(false);
        AlertFunction('');
    }, []);


    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }


    useEffect(() => {
        if(!targetId) {
            const localTargetId = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.USER_ID));
            if(localTargetId) {
                setTargetId(localTargetId);
            } else {
                navigate(`${PAGE_URL.ERRORPAGE}`);
            }
        } else {
            sessionStorage.setItem(SESSIONSTORAGE.USER_ID, base64Encoding(targetId));
        }
    }, [props]);


    useEffect(() => {
        if(targetId) {
            loadAccount();
        }
    }, [targetId]);


    useEffect(() => {
        if(targetId && refreshYn) {
            loadAccount();
        }
    }, [refreshYn]);



    function loadAccount() {
        props.setLoading(true);
        requests.get(PLATFORM_URL.USERS + "/" + targetId)
        .then((response) => {
            if (response.status === 200 && response.data) {
                setRefreshYn(false);
                setMyInfoData(response.data);
            }
            props.setLoading(false);
        })
        .catch((_) => {
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            setRefreshYn(false);
            props.setLoading(false);
        });
    }


    function updateAccountResult(data) {
        if(data.successYn) {
            AlertFunction(t("MESSAGE_ACCOUNT_UPDATE_SUCCESS_MESSAGE"));
            setRefreshYn(true);
        }
    }


    function clickChagePassword() {
        navigate(`${PAGE_URL.CHANGEPWD}`)
    }


    function clickUpdateAccount() {
        if(props.showSlideModalCb) {
            props.showSlideModalCb({...accountUpdateModalContent, openYn: true, resultCb: updateAccountResult, args: myInfoData});
        }
    }


    return (
        <MyInfoDetail
            changePasswordFunction={clickChagePassword}
            updateAccountFunction={clickUpdateAccount}
            detailData={myInfoData}
            infoText={infoText}
            infoError={infoError}
        />
    );
}
